import { Const } from '@/const'

import { CreateGetParamHelper } from "@/helper/createGetParamHelper"
import { CreatePostParamHelper } from "@/helper/createPostParamHelper"
import { DebugHelper } from "@/helper/debugHelper";

export class RequestHelper
{
    public static get(api : string, postData : { [ key : string ] : string } | null, completion : (response : string) => void, error : () => void)
    {
        var url = this.getApiUrl(api) + this.getQuery(postData);
        DebugHelper.trace("request url: " + url);

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = (() =>
        {
            if(xhr.readyState == XMLHttpRequest.DONE)
            {
                if(xhr.status == 200)
                {
                    DebugHelper.trace(url, xhr.response);
                    completion(xhr.response);
                }
                else
                {
                    error();
                }
            }
        });
        xhr.send(null);
    }

    // 同期リクエスト: 非推奨なので使わざるを得ないときのみ
    public static getSync(api : string, postData : { [ key : string ] : string } | null)
    {
        var url = this.getApiUrl(api) + this.getQuery(postData);
        DebugHelper.trace("request url: " + url);
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, false);
        xhr.send(null);
        if(xhr.status == 200)
        {
            return xhr.response;
        }
        else
        {
            DebugHelper.trace("error");
            return "";
        }
    }

    public static post(api : string, postData : { [ key : string ] : string } | null, completion : (response : string) => void, error : () => void)
    {
        const XHR = new XMLHttpRequest();

        XHR.onload = () => {
            if(XHR.status == 200)
            {
                DebugHelper.trace(url, XHR.response);
                completion(XHR.response);
            }
            else
            {
                error();
            }
        }

        var url = this.getApiUrl(api);
        DebugHelper.trace(postData);

        XHR.open( 'POST', url );
        XHR.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
        XHR.send(CreatePostParamHelper.createPostParam(postData));
    }


    // filename : xxx.svg
    // mimeType : image/svg+xml
    public static postBinary(api : string, buf : ArrayBuffer, filename : string, mimeType : string, completion : (response : string) => void, error : () => void)
    {
        var url = this.getApiUrl(api);
        DebugHelper.trace("request url: " + url);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        var boundary = this.createBoundary();
        xhr.setRequestHeader("Content-Type", 'multipart/form-data; boundary=' + boundary );
        // imageとして送る。
        var buffer = this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: name="image"; filename="' + filename + '"\r\n'
        + 'Content-Type: ' + mimeType + '\r\n\r\n');
        buffer = this.appendBuffer(buffer, buf);
        buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n' + '--' + boundary + '--'));
        xhr.onreadystatechange = (() =>
        {
            if(xhr.readyState == XMLHttpRequest.DONE)
            {
                if(xhr.status == 200)
                {
                    completion(xhr.response);
                }
                else
                {
                    error();
                }
            }
        });
        DebugHelper.trace(buffer)
        xhr.send(buffer);
    }

    public static postBinaryWithData(api : string, postData : { [ key : string ] : string } | null, buf : ArrayBuffer, filename : string, mimeType : string, completion : (response : string) => void, error : () => void)
    {
        var url = Const.API_URL_BASE + api + ".php";
        DebugHelper.trace("request url: " + url);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        var boundary = this.createBoundary();
        xhr.setRequestHeader("Content-Type", 'multipart/form-data; boundary=' + boundary );
        // imageとして送る。
        var buffer = this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: name="image"; filename="' + filename + '"\r\n'
        + 'Content-Type: ' + mimeType + '\r\n\r\n');
        buffer = this.appendBuffer(buffer, buf);
        buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
        var addData = false;
        if(postData != null)
        {
            for(var key in postData)
            {
                buffer = this.appendBuffer(buffer, this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: form-data; name="' + key +'"\r\n\r\n'));
                buffer = this.appendBuffer(buffer, this.unicode2buffer("" + postData[key]));
                buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
                addData = true;
            }
        }

        if(!addData)
        {
            buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
        }
        buffer = this.appendBuffer(buffer, this.unicode2buffer('--' + boundary + '--'));
        xhr.onreadystatechange = (() =>
        {
            if(xhr.readyState == XMLHttpRequest.DONE)
            {
                if(xhr.status == 200)
                {
                    completion(xhr.response);
                }
                else
                {
                    error();
                }
            }
        });
        DebugHelper.trace(buffer)
        xhr.send(buffer);
    }

    public static postMultiBinary(api : string, postData : { [ key : string ] : string } | null, bufArray : Array<ArrayBuffer>, filenameArray : Array<string>, mimeType : string, completion : (response : string) => void, error : () => void)
    {
        if(bufArray.length == 0 || filenameArray.length == 0 || bufArray.length != filenameArray.length)
        {
            DebugHelper.trace("parameter error!");
            error();
            return;
        }

        var url = this.getApiUrl(api);
        DebugHelper.trace("request url: " + url);
        DebugHelper.trace("file names:");
        DebugHelper.trace(filenameArray);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        var boundary = this.createBoundary();
        xhr.setRequestHeader("Content-Type", 'multipart/form-data; boundary=' + boundary );
        var buffer = this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: name="' + filenameArray[0] + '"; filename="' + filenameArray[0] + '"\r\n'
                + 'Content-Type: ' + mimeType + '\r\n\r\n');
        for(var i = 0; i < bufArray.length; ++i)
        {
            // imageとして送る。
            if(i > 0)
            {
                buffer = this.appendBuffer(buffer, this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: name="' + filenameArray[i] + '"; filename="' + filenameArray[i] + '"\r\n'
                + 'Content-Type: ' + mimeType + '\r\n\r\n'));
            }
            buffer = this.appendBuffer(buffer, bufArray[i]);
            buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
        }

        var addData = false;
        if(postData != null)
        {
            for(var key in postData)
            {
                buffer = this.appendBuffer(buffer, this.unicode2buffer('--' + boundary + '\r\n' + 'Content-Disposition: form-data; name="' + key +'"\r\n\r\n'));
                buffer = this.appendBuffer(buffer, this.unicode2buffer("" + postData[key]));
                buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
                addData = true;
            }
        }

        if(!addData)
        {
            buffer = this.appendBuffer(buffer, this.unicode2buffer('\r\n'));
        }
        buffer = this.appendBuffer(buffer, this.unicode2buffer('--' + boundary + '--'));
        xhr.onreadystatechange = (() =>
        {
            if(xhr.readyState == XMLHttpRequest.DONE)
            {
                if(xhr.status == 200)
                {
                    completion(xhr.response);
                }
                else
                {
                    error();
                }
            }
        });
        DebugHelper.trace(buffer)
        xhr.send(buffer);
    }

    private static createBoundary()
    {
        var multipartChars = "-_1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var length = 30 + Math.floor( Math.random() * 10 );
        var boundary = "---------------------------";
        for (var i = 0; i < length; i++) {
            boundary += multipartChars.charAt( Math.floor( Math.random() * multipartChars.length ) );
        }
        return boundary;
    }

    private static unicode2buffer(str){

        var n = str.length,
            idx = -1,
            byteLength = 512,
            bytes = new Uint8Array(byteLength),
            i, c, _bytes;

        for(i = 0; i < n; ++i){
            c = str.charCodeAt(i);
            if(c <= 0x7F){
                bytes[++idx] = c;
            } else if(c <= 0x7FF){
                bytes[++idx] = 0xC0 | (c >>> 6);
                bytes[++idx] = 0x80 | (c  & 0x3F);
            } else if(c <= 0xFFFF){
                bytes[++idx] = 0xE0 | (c >>> 12);
                bytes[++idx] = 0x80 | ((c >>> 6)  & 0x3F);
                bytes[++idx] = 0x80 | (c  & 0x3F);
            } else {
                bytes[++idx] = 0xF0 | (c >>> 18);
                bytes[++idx] = 0x80 | ((c >>> 12)  & 0x3F);
                bytes[++idx] = 0x80 | ((c >>> 6)  & 0x3F);
                bytes[++idx] = 0x80 | (c  & 0x3F);
            }
            if(byteLength - idx <= 4){
                _bytes = bytes;
                byteLength *= 2;
                bytes = new Uint8Array(byteLength);
                bytes.set(_bytes);
            }
        }
        idx++;

        var result = new Uint8Array(idx);
        result.set(bytes.subarray(0,idx),0);

        return result.buffer as ArrayBuffer;
    }

    private static appendBuffer(buf1, buf2)
    {
        var uint8array = new Uint8Array(buf1.byteLength + buf2.byteLength);
        uint8array.set(new Uint8Array(buf1),0);
        uint8array.set(new Uint8Array(buf2),buf1.byteLength);
        return uint8array.buffer as ArrayBuffer;
    }

    public static getApiUrl(api : string)
    {
        if(DebugHelper.isDebugMode)
        {
            // デバッグモードの場合はそのまま
            return Const.API_URL_BASE + api + ".php";
        }
        else
        {
            if(api == "get_product_category_list" ||
                api == "get_template_list" ||
                api == "get_template_new_list" ||
                api == "get_image_list" ||
                api == "get_image_category_list" ||
                api == "get_template_category_list" ||
                api == "get_template_content" ||
                api == "get_template_new_content" ||
                api == "get_font_json")
            {
                // 一部のAPIはCDNを使う
                return Const.API_URL_BASE_CDN + api + ".php";
            }
            else
            {
                return Const.API_URL_BASE + api + ".php";
            }
        }
    }
    private static getQuery(postData : { [ key : string ] : string } | null)
    {
        if(postData == null) { return ""; }
        var query = "?";
        for(var key in postData)
        {
            query += key;
            query += "=";
            query += postData[key];
            query += "&";
        }
        if(query.length > 0 && query.substr(query.length - 1, 1) == "&")
        {
            // 最後の"&"を削除
            query = query.substr(0, query.length - 1);
        }
        return query;
    }

    static readonly GOOGLE_API_KEY = "AIzaSyAOoq_ecVOqEmU3nu42_txVPvcEEaw1dzQ";

    public static getGoogleFont(completion : (response : string) => void, error : () => void)
    {
        var url = 'https://www.googleapis.com/webfonts/v1/webfonts?key=' + this.GOOGLE_API_KEY;
        DebugHelper.trace("request url: " + url);

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onreadystatechange = (() =>
        {
            if(xhr.readyState == XMLHttpRequest.DONE)
            {
                if(xhr.status == 200)
                {
                    completion(xhr.response);
                }
                else
                {
                    error();
                }
            }
        });
        xhr.send(null);
    }
}
